import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SchoolPublicPage from "./public/SchoolPublicPage";
import SchoolLoginPage from "./public/SchoolLoginPage";
import StudentApplicationPage from "./public/StudentApplicationPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import PwaRootLanding from "../components/pwa/PwaRootLanding";

/**
 * Routes served on a school subdomain ({slug}.edumanagemalawi.com).
 * Public site at /, school login at /login.
 */
export default function SchoolSubdomainApp({ subdomain }) {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <PwaRootLanding browserElement={<SchoolPublicPage schoolSlugFromHost={subdomain} />} />
                }
            />
            <Route path="/apply" element={<StudentApplicationPage schoolSlugFromHost={subdomain} />} />
            <Route path="/login" element={<SchoolLoginPage schoolSlugFromHost={subdomain} />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage loginPath="/login" />} />
            <Route path="/reset-password" element={<ResetPasswordPage loginPath="/login" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
